module.exports = __webpack_public_path__ + "img/routerDefaultImg3x.68d2d648.png";